import React from "react";
const RightBoldIcon = () => (
<svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M20.0175 12.4286H0V16.5714H20L11.8739 26.0811L15 29L28 14.5L15 0L12.1366 2.91875L20.0175 12.4286Z" fill="white"/>
</svg>
);
export default RightBoldIcon;
